import { render } from "./AppListItem.vue?vue&type=template&id=c2bef4d6&scoped=true"
import script from "./AppListItem.vue?vue&type=script&lang=js"
export * from "./AppListItem.vue?vue&type=script&lang=js"

import "./AppListItem.vue?vue&type=style&index=0&id=c2bef4d6&lang=scss&scoped=true"
import "./AppListItem.vue?vue&type=style&index=1&id=c2bef4d6&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bef4d6"]])

export default __exports__